module.exports = __webpack_public_path__ + "img/010.c277aaed.jpg";